module.exports = __webpack_public_path__ + "img/kr-product-supply-chain-card2-icon.d2443a3.png";